import React, { Suspense, useEffect, useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import { SubTitle } from "../../Components/CustomComponents/index.js";
import Table from "../../Components/Table/Table.js";
import styles from "./styles/user_management.module.scss";
// import { ToastContainer, toast } from "react-toastify";
import { FaUserEdit } from "react-icons/fa";
//
import { useDispatch } from "react-redux"; // for getting and setting data into local redux
// import CustomerBlockModal from "../../Components/Modals/CustomerBlockModal";
import { Spinner } from "react-bootstrap";
// import EditBusinessTypeModal from "../../Components/Modals/EditBusinessTypeModal.js";
import EditPackageModal from "../../Components/Modals/EditPackageModal.js";
import DetailGameCategoryModal from "../../Components/Modals/DetailGameCategoryModal.js";
import { useGetAllGameCategoriesQuery } from "../../Data/services/gameApi.js";
import CustomLoader from "../../Components/CustomComponents/CustomLoader.js";
// import { useDeleteBusinessTypeMutation, useGetAllBusinessTypeMutation, useGetAllBusinessTypeQuery } from "../../Data/services/businessTypeApi.js";
// import CustomLoader from "../../Components/CustomComponents/CustomLoader.js";
// const CustomerBlockModal = lazy(() =>
//   import("../../Components/Modals/CustomerBlockModal.js")
// );

const GameCategoriesManagementScreen = ({ setPage }) => {
  const dispatch = useDispatch();

  // const [data, setData] = useState([]);
  const [indicationMessage, setIndicationMessage] = useState("loading...");
  const [rowData, setRowData] = useState([]);
  const [editedData, setEditedData] = useState("");

  const [loading, setLoading] = useState(false);
  const [editModal, setEditModal] = useState(false);

  const [currentPage, setCurrentPage] = useState(1); // todo
  const [pageSize, setPageSize] = useState(10); // todo
  const [totalRecords, setTotalRecords] = useState(0); // todo
  const [totalPages, setTotalPages] = useState(0); // todo
  const [dataFetched, setDataFetched] = useState(false); // todo

  const [searchQuery, setSearchQuery] = useState("");

  const dummyData = [
    {
      id: 216,
      game_id: 78,
      category_id: 1,
      user_id: 34,
      is_completed: true,
      createdAt: "2025-04-21T14:39:13.000Z",
      updatedAt: "2025-04-21T14:43:11.000Z",
      deletedAt: null,
      start_at: "2025-04-21T14:43:00.000Z",
      end_at: "2025-04-21T14:43:11.000Z",
      category: {
        name: {
          en: "Football",
          ar: "كرة القدم",
        },
        image:
          "http://api.focustrivia.trangotechdevs.com:3066/category/1741588897095.jpeg",
        updatedAt: "2025-03-10T06:42:18.000Z",
        deletedAt: null,
      },
    },
    {
      id: 215,
      game_id: 78,
      category_id: 4,
      user_id: 34,
      is_completed: false,
      createdAt: "2025-04-21T14:39:13.000Z",
      updatedAt: "2025-04-21T14:42:47.000Z",
      deletedAt: null,
      start_at: null,
      end_at: null,
      category: {
        name: {
          en: "Medicine",
          ar: "دواء",
        },
        image:
          "http://api.focustrivia.trangotechdevs.com:3066/category/1741589452245.png",
        updatedAt: "2025-03-10T06:51:03.000Z",
        deletedAt: null,
      },
    },
    {
      id: 214,
      game_id: 78,
      category_id: 5,
      user_id: 34,
      is_completed: false,
      createdAt: "2025-04-21T14:39:13.000Z",
      updatedAt: "2025-04-21T14:42:47.000Z",
      deletedAt: null,
      start_at: null,
      end_at: null,
      category: {
        name: {
          en: "Date",
          ar: "تاريخ",
        },
        image:
          "http://api.focustrivia.trangotechdevs.com:3066/category/1741589540734.png",
        updatedAt: "2025-03-10T06:52:30.000Z",
        deletedAt: null,
      },
    },
    {
      id: 213,
      game_id: 78,
      category_id: 6,
      user_id: 34,
      is_completed: false,
      createdAt: "2025-04-21T14:39:13.000Z",
      updatedAt: "2025-04-21T14:42:47.000Z",
      deletedAt: null,
      start_at: null,
      end_at: null,
      category: {
        name: {
          en: "Fashion",
          ar: "موضة",
        },
        image:
          "http://api.focustrivia.trangotechdevs.com:3066/category/1741589623775.png",
        updatedAt: "2025-03-10T06:53:56.000Z",
        deletedAt: null,
      },
    },
    {
      id: 212,
      game_id: 78,
      category_id: 8,
      user_id: 34,
      is_completed: true,
      createdAt: "2025-04-21T14:39:13.000Z",
      updatedAt: "2025-04-21T14:42:58.000Z",
      deletedAt: null,
      start_at: "2025-04-21T14:42:49.000Z",
      end_at: "2025-04-21T14:42:58.000Z",
      category: {
        name: {
          en: "Music",
          ar: "موسيقى",
        },
        image:
          "http://api.focustrivia.trangotechdevs.com:3066/category/1741589782713.png",
        updatedAt: "2025-03-10T06:56:35.000Z",
        deletedAt: null,
      },
    },
    {
      id: 211,
      game_id: 78,
      category_id: 7,
      user_id: 34,
      is_completed: false,
      createdAt: "2025-04-21T14:39:13.000Z",
      updatedAt: "2025-04-21T14:42:47.000Z",
      deletedAt: null,
      start_at: null,
      end_at: null,
      category: {
        name: {
          en: "Climate",
          ar: "مناخ",
        },
        image:
          "http://api.focustrivia.trangotechdevs.com:3066/category/1741589709913.png",
        updatedAt: "2025-03-10T06:55:25.000Z",
        deletedAt: null,
      },
    },
    {
      id: 210,
      game_id: 77,
      category_id: 9,
      user_id: 34,
      is_completed: false,
      createdAt: "2025-04-21T14:37:35.000Z",
      updatedAt: "2025-04-21T14:37:35.000Z",
      deletedAt: null,
      start_at: null,
      end_at: null,
      category: {
        name: {
          en: "Sciences",
          ar: "العلوم",
        },
        image:
          "http://api.focustrivia.trangotechdevs.com:3066/category/1741589867693.png",
        updatedAt: "2025-03-10T06:58:04.000Z",
        deletedAt: null,
      },
    },
    {
      id: 209,
      game_id: 77,
      category_id: 4,
      user_id: 34,
      is_completed: false,
      createdAt: "2025-04-21T14:37:35.000Z",
      updatedAt: "2025-04-21T14:37:35.000Z",
      deletedAt: null,
      start_at: null,
      end_at: null,
      category: {
        name: {
          en: "Medicine",
          ar: "دواء",
        },
        image:
          "http://api.focustrivia.trangotechdevs.com:3066/category/1741589452245.png",
        updatedAt: "2025-03-10T06:51:03.000Z",
        deletedAt: null,
      },
    },
    {
      id: 208,
      game_id: 77,
      category_id: 8,
      user_id: 34,
      is_completed: false,
      createdAt: "2025-04-21T14:37:35.000Z",
      updatedAt: "2025-04-21T14:37:35.000Z",
      deletedAt: null,
      start_at: null,
      end_at: null,
      category: {
        name: {
          en: "Music",
          ar: "موسيقى",
        },
        image:
          "http://api.focustrivia.trangotechdevs.com:3066/category/1741589782713.png",
        updatedAt: "2025-03-10T06:56:35.000Z",
        deletedAt: null,
      },
    },
    {
      id: 207,
      game_id: 77,
      category_id: 7,
      user_id: 34,
      is_completed: false,
      createdAt: "2025-04-21T14:37:35.000Z",
      updatedAt: "2025-04-21T14:37:35.000Z",
      deletedAt: null,
      start_at: null,
      end_at: null,
      category: {
        name: {
          en: "Climate",
          ar: "مناخ",
        },
        image:
          "http://api.focustrivia.trangotechdevs.com:3066/category/1741589709913.png",
        updatedAt: "2025-03-10T06:55:25.000Z",
        deletedAt: null,
      },
    },
    {
      id: 206,
      game_id: 77,
      category_id: 6,
      user_id: 34,
      is_completed: false,
      createdAt: "2025-04-21T14:37:35.000Z",
      updatedAt: "2025-04-21T14:37:35.000Z",
      deletedAt: null,
      start_at: null,
      end_at: null,
      category: {
        name: {
          en: "Fashion",
          ar: "موضة",
        },
        image:
          "http://api.focustrivia.trangotechdevs.com:3066/category/1741589623775.png",
        updatedAt: "2025-03-10T06:53:56.000Z",
        deletedAt: null,
      },
    },
    {
      id: 205,
      game_id: 77,
      category_id: 5,
      user_id: 34,
      is_completed: false,
      createdAt: "2025-04-21T14:37:35.000Z",
      updatedAt: "2025-04-21T14:37:35.000Z",
      deletedAt: null,
      start_at: null,
      end_at: null,
      category: {
        name: {
          en: "Date",
          ar: "تاريخ",
        },
        image:
          "http://api.focustrivia.trangotechdevs.com:3066/category/1741589540734.png",
        updatedAt: "2025-03-10T06:52:30.000Z",
        deletedAt: null,
      },
    },
    {
      id: 204,
      game_id: 76,
      category_id: 4,
      user_id: 26,
      is_completed: false,
      createdAt: "2025-04-21T13:22:13.000Z",
      updatedAt: "2025-04-21T13:52:23.000Z",
      deletedAt: null,
      start_at: null,
      end_at: null,
      category: {
        name: {
          en: "Medicine",
          ar: "دواء",
        },
        image:
          "http://api.focustrivia.trangotechdevs.com:3066/category/1741589452245.png",
        updatedAt: "2025-03-10T06:51:03.000Z",
        deletedAt: null,
      },
    },
    {
      id: 203,
      game_id: 76,
      category_id: 5,
      user_id: 26,
      is_completed: false,
      createdAt: "2025-04-21T13:22:13.000Z",
      updatedAt: "2025-04-21T13:52:23.000Z",
      deletedAt: null,
      start_at: null,
      end_at: null,
      category: {
        name: {
          en: "Date",
          ar: "تاريخ",
        },
        image:
          "http://api.focustrivia.trangotechdevs.com:3066/category/1741589540734.png",
        updatedAt: "2025-03-10T06:52:30.000Z",
        deletedAt: null,
      },
    },
    {
      id: 202,
      game_id: 76,
      category_id: 7,
      user_id: 26,
      is_completed: false,
      createdAt: "2025-04-21T13:22:13.000Z",
      updatedAt: "2025-04-21T13:52:23.000Z",
      deletedAt: null,
      start_at: null,
      end_at: null,
      category: {
        name: {
          en: "Climate",
          ar: "مناخ",
        },
        image:
          "http://api.focustrivia.trangotechdevs.com:3066/category/1741589709913.png",
        updatedAt: "2025-03-10T06:55:25.000Z",
        deletedAt: null,
      },
    },
    {
      id: 201,
      game_id: 76,
      category_id: 6,
      user_id: 26,
      is_completed: false,
      createdAt: "2025-04-21T13:22:13.000Z",
      updatedAt: "2025-04-21T13:52:23.000Z",
      deletedAt: null,
      start_at: null,
      end_at: null,
      category: {
        name: {
          en: "Fashion",
          ar: "موضة",
        },
        image:
          "http://api.focustrivia.trangotechdevs.com:3066/category/1741589623775.png",
        updatedAt: "2025-03-10T06:53:56.000Z",
        deletedAt: null,
      },
    },
    {
      id: 200,
      game_id: 76,
      category_id: 9,
      user_id: 26,
      is_completed: false,
      createdAt: "2025-04-21T13:22:13.000Z",
      updatedAt: "2025-04-21T13:56:58.000Z",
      deletedAt: null,
      start_at: "2025-04-21T13:56:58.000Z",
      end_at: null,
      category: {
        name: {
          en: "Sciences",
          ar: "العلوم",
        },
        image:
          "http://api.focustrivia.trangotechdevs.com:3066/category/1741589867693.png",
        updatedAt: "2025-03-10T06:58:04.000Z",
        deletedAt: null,
      },
    },
    {
      id: 199,
      game_id: 76,
      category_id: 1,
      user_id: 26,
      is_completed: true,
      createdAt: "2025-04-21T13:22:13.000Z",
      updatedAt: "2025-04-21T13:52:57.000Z",
      deletedAt: null,
      start_at: "2025-04-21T13:52:27.000Z",
      end_at: "2025-04-21T13:52:57.000Z",
      category: {
        name: {
          en: "Football",
          ar: "كرة القدم",
        },
        image:
          "http://api.focustrivia.trangotechdevs.com:3066/category/1741588897095.jpeg",
        updatedAt: "2025-03-10T06:42:18.000Z",
        deletedAt: null,
      },
    },
    {
      id: 198,
      game_id: 75,
      category_id: 8,
      user_id: 26,
      is_completed: true,
      createdAt: "2025-04-21T13:13:34.000Z",
      updatedAt: "2025-04-21T13:30:46.000Z",
      deletedAt: null,
      start_at: null,
      end_at: null,
      category: {
        name: {
          en: "Music",
          ar: "موسيقى",
        },
        image:
          "http://api.focustrivia.trangotechdevs.com:3066/category/1741589782713.png",
        updatedAt: "2025-03-10T06:56:35.000Z",
        deletedAt: null,
      },
    },
    {
      id: 197,
      game_id: 75,
      category_id: 7,
      user_id: 26,
      is_completed: true,
      createdAt: "2025-04-21T13:13:34.000Z",
      updatedAt: "2025-04-21T13:30:46.000Z",
      deletedAt: null,
      start_at: null,
      end_at: null,
      category: {
        name: {
          en: "Climate",
          ar: "مناخ",
        },
        image:
          "http://api.focustrivia.trangotechdevs.com:3066/category/1741589709913.png",
        updatedAt: "2025-03-10T06:55:25.000Z",
        deletedAt: null,
      },
    },
  ];

  const { data, isSuccess, isLoading, isFetching, refetch } =
    useGetAllGameCategoriesQuery(
      {
        search: searchQuery.length >= 3 ? searchQuery : "",
        limit: pageSize,
        page: currentPage,
      },
      { refetchOnMountOrArgChange: true }
    );

  useEffect(() => {
    if (data) {
      // console.log(data);
      setPageSize(data.links.per_page);
      setCurrentPage(data.links.current);
      setTotalRecords(data.links.total_records);
      setTotalPages(data.links.total);
      setRowData(data.data);
      setDataFetched(true);
    }
  }, [data]);

  // const debouncedSearch = useCallback(
  //   debounce((query) => {
  //     console.log("Search query:", query);
  //     // local search logic
  //     const filtered = dummy_data.filter((item) =>
  //       [item.firstname, item.lastname, item.username, item.email]
  //         .filter(Boolean) // Remove null/undefined fields
  //         .some((field) => field.toLowerCase().includes(query.toLowerCase()))
  //     );

  //     setRowData(filtered);

  //     // Trigger your search logic or API here
  //   }, 500), // Adjust debounce delay as needed
  //   []
  // );

  const handleSearchChange = (event) => {
    const query = event.target.value;
    // console.log("Search query:", query); // You can use this to trigger a search function
    setSearchQuery(query);

    // debouncedSearch(query);
  };

  const handleEditModalOpen = () => {
    setEditModal(true);
  };

  const handleEditModalClose = () => {
    setEditModal(false);
    setEditedData("");
  };

  const handleAddUser = () => {
    setEditModal(true);
  };

  function indication() {
    // return something here
    // return 'Table is empty';
    return indicationMessage;
  }

  const columns = [
    {
      dataField: "category.name.en",
      text: "Level Name",
      sort: true,
      headerStyle: {
        width: "200px",
      },
    },
    {
      dataField: "category.image",
      text: "Image",
      sort: true,
      headerStyle: {
        width: "100px",
      },
      formatter: (cellContent, row) => {
        // return row.firstname + row.lastname;
        return (
          <img
            alt="package"
            src={row.category.image}
            loading="lazy"
            width={62}
            height={62}
            className="rounded-circle object-fit-cover"
          />
        );
      },
    },
    {
      dataField: "actions",
      text: "Actions",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "200px",
      },
      formatter: (cellContent, row) => {
        // console.log(row)
        if (row.slug || row.id) {
          return (
            <div className="d-flex justify-content-center align-items-center ">
              <div
                className={`${styles.btnBg} d-flex justify-content-center align-items-center rounded-3 mx-2 p-2 text-white`}
                role="button"
                onClick={() => {
                  setEditedData(row);
                  handleEditModalOpen(true);
                }}
              >
                <span
                  className={`align-items-center d-flex justify-content-center pe-1  `}
                ></span>
                <span>Details</span>
              </div>
            </div>
          );
        }
      },
    },
  ];

  return (
    <div className={styles.MainContainer}>
      {editModal ? (
        <Suspense fallback={<Spinner animation="grow" size="sm" />}>
          <DetailGameCategoryModal
            handleEditModalClose={handleEditModalClose}
            editData={editedData}
            // refetch={refetch}
          />
        </Suspense>
      ) : (
        ""
      )}

      <div className={styles.headerContainer}>
        <div>
          <SubTitle text={"Game Categories Management"} classes="text-black" />
        </div>

        {
          // <Row>
          //   <Col md={12}>
          //     <Button
          //       classes={`${styles.cardBtn} `}
          //       text="Add Package"
          //       onClick={handleAddUser}
          //     ></Button>
          //   </Col>
          // </Row>
        }
      </div>

      <div className={styles.mainTable}>
        {!dataFetched || isLoading ? (
          <CustomLoader />
        ) : (
          <div className={styles.mainTable}>
            {
              <Table
                classes={`${dataFetched && isFetching ? "blur-table" : ""}`}
                data={rowData || []}
                columns={columns}
                indication={indication}
                totalRecords={totalRecords} // todo
                totalPages={totalPages} // todo
                pageSize={pageSize} // todo
                currentPage={currentPage} // todo
                setCurrentPage={setCurrentPage} // todo
                setPageSize={setPageSize} // todo
                // refetch={refetch} // todo
                refetch={() => {}} // todo
              />
            }
          </div>
        )}
      </div>
    </div>
  );
};

export default GameCategoriesManagementScreen;
